<template lang="pug">
  v-card(v-if="currentAnimalType")
    v-card-title
      h2.modal-title {{ $t('base.edit_animal_type') }}
    v-card-content
      v-input-r(
        :label="$t('base.type_animal_type_name')"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        @input="clearError('name')"
        v-model="currentAnimalType.name")
    v-card-actions
      v-btn(
        @click="onUpdate"
        :loading="loading") {{ $t('base.save') }}
      delete-btn(
        @delete="onDelete")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
import DeleteBtn from '@/components/common/delete-btn/DeleteBtn'

export default {
  name: 'SettingsTypeModal',
  mixins: [formErrorsMixin],

  components: {
    DeleteBtn
  },

  data: () => ({
    loading: false,
    errors: {
      name: null
    }
  }),

  computed: {
    ...mapGetters('animaltypes', [
      'currentAnimalType'
    ])
  },

  methods: {
    ...mapActions('animaltypes', [
      'updateAnimalType',
      'deleteAnimalType'
    ]),

    checkValidData () {
      const errorCodes = { REQUIRED: '4' }
      let valid = true

      if (!this.currentAnimalType.name || !this.currentAnimalType.name.trim()) {
        this.errors.name = [errorCodes.REQUIRED]
        valid = false
      }

      if (!valid) {
        this.loading = false
        return false
      }

      return true
    },

    async onUpdate () {
      this.loading = true

      if (!this.checkValidData()) return

      const error = await this.updateAnimalType()

      this.loading = false

      if (!error) {
        this.$emit('update')
      } else {
        this.$toasted.error(this.$t('errors.incorrect_data'))
      }
    },

    async onDelete () {
      await this.deleteAnimalType()
      this.$emit('remove')
    }
  }
}
</script>
<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
  display: flex;
  gap: 1rem;
}

.v-card__actions button:first-child {
  flex: 1;
}
</style>